import React from "react";

const Footer = () => {
  return (
    <footer>
      <div>
        <h1>MyHerupa2</h1>
        <p>@all rights reserved</p>
      </div>
      <div>
        <h5>Follow us</h5>
        <div>
          <a href="https://www.youtube.com/" target={"blank"}>
            Youtube
          </a>
          <a href="" target={"blank"}>
            Instagram
          </a>
          <a
            href="https://github.com/Akhil-Sharma-26/code-hunters"
            target={"blank"}
          >
            Github
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
